export default function Contact() {
  return (
    <section id="contacto" className="py-24 bg-gradient-to-b from-[#0f0520] via-[#1a0b2e] to-[#2d1b4e] relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/3 w-96 h-96 bg-[#ff00ff] rounded-full mix-blend-screen filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/3 w-96 h-96 bg-[#00ffff] rounded-full mix-blend-screen filter blur-3xl animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-gradient-to-r from-[#ff00ff]/20 to-[#00ffff]/20 backdrop-blur-sm border border-[#00ffff]/30 px-5 py-2 rounded-full mb-6">
            <span className="text-xs font-bold text-[#00ffff] uppercase tracking-wide">
              Contacto
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            ¿Listo para transformar tu marca?
          </h2>
          <p className="text-xl text-[#c0c0ff]">
            Contáctanos hoy y comienza a crear diseños que impulsen tu negocio
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {/* WhatsApp */}
          <a
            href="https://wa.me/527131055034"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gradient-to-br from-[#1a0b2e]/80 to-[#2d1b4e]/80 backdrop-blur-sm border border-[#00ffff]/20 rounded-2xl p-8 hover:border-[#ff00ff]/50 transition-all duration-300 cursor-pointer hover:shadow-2xl hover:shadow-[#ff00ff]/30 hover:scale-105 text-center"
          >
            <div className="w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-[#ff00ff] to-[#ff00aa] mx-auto mb-6 shadow-lg shadow-[#ff00ff]/50 group-hover:scale-110 transition-transform">
              <i className="ri-whatsapp-line text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">WhatsApp</h3>
            <p className="text-[#00ffff] font-semibold mb-2">7131055034</p>
            <p className="text-[#c0c0ff] text-sm">Respuesta inmediata</p>
          </a>

          {/* Email */}
          <a
            href="mailto:logoideas05@gmail.com"
            className="group bg-gradient-to-br from-[#1a0b2e]/80 to-[#2d1b4e]/80 backdrop-blur-sm border border-[#00ffff]/20 rounded-2xl p-8 hover:border-[#ff00ff]/50 transition-all duration-300 cursor-pointer hover:shadow-2xl hover:shadow-[#ff00ff]/30 hover:scale-105 text-center"
          >
            <div className="w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-[#00ffff] to-[#0099ff] mx-auto mb-6 shadow-lg shadow-[#00ffff]/50 group-hover:scale-110 transition-transform">
              <i className="ri-mail-line text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">Email</h3>
            <p className="text-[#00ffff] font-semibold mb-2 break-all">logoideas05@gmail.com</p>
            <p className="text-[#c0c0ff] text-sm">Cotizaciones detalladas</p>
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/share/1AefDud4bR/"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gradient-to-br from-[#1a0b2e]/80 to-[#2d1b4e]/80 backdrop-blur-sm border border-[#00ffff]/20 rounded-2xl p-8 hover:border-[#ff00ff]/50 transition-all duration-300 cursor-pointer hover:shadow-2xl hover:shadow-[#ff00ff]/30 hover:scale-105 text-center"
          >
            <div className="w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-[#ff00aa] to-[#ff0066] mx-auto mb-6 shadow-lg shadow-[#ff00aa]/50 group-hover:scale-110 transition-transform">
              <i className="ri-facebook-fill text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">Facebook</h3>
            <p className="text-[#00ffff] font-semibold mb-2">@LogoIdeas</p>
            <p className="text-[#c0c0ff] text-sm">Síguenos para inspiración</p>
          </a>
        </div>

        {/* CTA Banner */}
        <div className="bg-gradient-to-r from-[#ff00ff] via-[#00ffff] to-[#ff00aa] rounded-3xl p-12 text-center shadow-2xl shadow-[#ff00ff]/50">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6">
            ¡Comienza tu proyecto hoy!
          </h3>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Diseños profesionales que convierten ideas en marcas memorables
          </p>
          <a
            href="https://wa.me/527131055034"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-[#1a0b2e] px-12 py-5 rounded-full font-bold text-lg hover:scale-105 transition-transform cursor-pointer whitespace-nowrap shadow-2xl"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            SOLICITA TU COTIZACIÓN GRATIS
          </a>
        </div>
      </div>
    </section>
  );
}
